import { render, staticRenderFns } from "./sections_field.vue?vue&type=template&id=33724948&lang=pug"
import script from "./sections_field.vue?vue&type=script&lang=js"
export * from "./sections_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports